import React, { useState } from "react";
import "./index.css";
import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { NavLink, useNavigate } from "react-router-dom";
import {
  formatDateWithMonth,
  onChangeToNumber,
  validateEmail,
} from "../../../../utils/helperFunction";
import { useDispatch, useSelector } from "react-redux";
import { setdetailFromInfoFormData } from "../../../../redux/slice/DetailReportSummarySlice";
import KitImagePreview from "../KitDetails/KitImagePreview";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";
const DetailedReportPageOne = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { detailFromInfoFormData } = useSelector((state) => state.DetailReport);
  // main state for the form data
  const [formData, setFormData] = useState(detailFromInfoFormData);
  const { quichReportData } = useSelector((state) => state.QUICKREPORT);
  //onchange function to set the input data
  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: { value: value, warning: !value ? true : false },
    }));
  };

  // to valdite the data of form on the click of the complete button
  const validateFormData = (e) => {
    e.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      firstName: { ...data.firstName, warning: !data.firstName.value },
      lastName: { ...data.lastName, warning: !data.lastName.value },
      phoneNumberCode: {
        ...data.phoneNumberCode,
        warning: !data.phoneNumberCode.value,
      },
      // phoneNumber: { ...data.phoneNumber, warning: !data.phoneNumber.value },
      email: { ...data.email, warning: validateEmail(data.email.value) },
    };
    setFormData({ ...data });
    if (
      !data.firstName.warning &&
      !data.lastName.warning &&
      !data.email.warning &&
      !data.phoneNumberCode.warning
    ) {
      dispatch(setdetailFromInfoFormData(formData));
      navigate("/detailedreportsummary");
    }
  };

  return (
    <div className="detailedReportPageOne open-sans-font flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <div className="mb-3 d-flex justify-content-center">
          <KitImagePreview url={quichReportData?.kit_data?.kit_picture} />
        </div>
        <h6 className="mb-3 fw-bold text-center">
          {quichReportData?.kit_data?.brand}&nbsp;
          {quichReportData?.kit_data?.model_number}&nbsp;
          {quichReportData?.kit_data?.product_name}
        </h6>
        <div className="button_info">
          <ProductDetailsButtonView />
          <hr className="my-4" />
          <div className="item_info">
            <h6 className="fw-bold mb-4 text-center">
              Please provide your information
            </h6>
            <Row className="row-gap-3 gx-3">
              <Col xs={6}>
                <Form.Group controlId="formBasicName">
                  <Form.Label className="d-none"></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First name"
                    name="firstName"
                    value={formData.firstName.value}
                    onChange={onChange}
                  />
                  {formData.firstName.warning && (
                    <p className="text-danger mt-1 mb-0">Enter first name</p>
                  )}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formBasic1Name">
                  <Form.Label className="d-none"></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last name"
                    name="lastName"
                    value={formData.lastName.value}
                    onChange={onChange}
                  />
                  {formData.lastName.warning && (
                    <p className="text-danger mt-1 mb-0">Enter last name</p>
                  )}
                </Form.Group>
              </Col>
              <Form.Group className="col-12" controlId="formBasicBusinessName">
                <div className="phn_input">
                  <div className="phone-input">
                    <PhoneInput
                      name="phoneNumberCode"
                      country={"gb"}
                      disableTyping={true}
                      inputProps={{
                        readOnly: true,
                      }}
                      value={formData.phoneNumberCode.value}
                      onChange={(value) =>
                        onChange({
                          target: {
                            name: "phoneNumberCode",
                            value: `+${value}`,
                          },
                        })
                      }
                    />
                  </div>
                  <Form.Control
                    onKeyPress={(e) => {
                      if (
                        e.key === "e" ||
                        e.key === "E" ||
                        isNaN(Number(e.key))
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    name="phoneNumber"
                    type="text"
                    pattern="[0-9]*"
                    value={onChangeToNumber(formData.phoneNumber.value)}
                    onChange={onChange}
                    placeholder="Number"
                  />
                </div>
                {(formData.phoneNumberCode.warning ||
                  formData.phoneNumber.warning) && (
                  <Stack direction="horizontal" gap={2}>
                    {formData.phoneNumberCode.warning && (
                      <p className="text-danger mt-1 mb-0">Enter phone code</p>
                    )}
                    {formData.phoneNumber.warning && (
                      <p className="text-danger mt-1 mb-0">
                        Enter phone number
                      </p>
                    )}
                  </Stack>
                )}
              </Form.Group>
              <Col xs={12}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className="d-none"></Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    onChange={onChange}
                    name="email"
                    value={formData.email.value}
                  />
                  {formData.email.warning && (
                    <p className="text-danger mt-1 mb-0">Enter valid email</p>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink className={"nav-link"} to="/standardwithquickreport">
          <Button variant="dark fw-bold h-100" type="button">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            variant="primary"
            type="button"
            className="button_custom fw-bold text-black"
            onClick={validateFormData}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailedReportPageOne;
